<template>
  <div :class="[$globalStyle.header, $globalStyle.playerHeader]">
    <template v-if="isMobile">
      <HeaderItemButton
        :icon-link="headerMenuIcon"
        :icon-only="true"
        :clickFunction="toggleMobileHeader"
        backBg="#333"
        frontBg="#676767"
        :button-width="'48px'"
      />
      <PlayerMobileHeader
        v-model="isMobileHeaderOpen"
        :user="user"
        :players-joined="playersJoined"
        :host="host"
        :player-group="playerGroup"
        :real-text-label="realTextLabel"
        :is-saboteur="isSaboteur"
        :saboteur="$t('saboteur')"
        :game-winner="gameWinner"
        :show-role-button="showRoleButton"
        :open-role-modal="openRoleModal"
      />
      <HeaderLanguageSelector />
    </template>
    <template v-else>
      <div :class="$globalStyle.headerLeft">
        <div v-if="user.name" :class="$globalStyle.headerItem">
          <div :class="$globalStyle.headerItemLabel">{{ $t("name") }}</div>
          <div :class="[$globalStyle.headerItemText]">
            {{ user.name }}
          </div>
        </div>
        <!-- <div v-if="allowedPlayers && playersJoined" :class="$globalStyle.headerItem">
          <div :class="$globalStyle.headerItemLabel">{{ $t('players') }}</div>
          <div :class="[$globalStyle.headerItemText]">
            {{ playersJoined }}
            <span :class="$globalStyle.headerItemSubText">/{{ allowedPlayers }}</span>
          </div>
        </div> -->
        <!-- <div v-if="playersJoined" :class="$globalStyle.headerItem">
          <div :class="$globalStyle.headerItemLabel">{{ $t("players") }}</div>
          <div :class="[$globalStyle.headerItemText]">
            {{ playersJoined }}
          </div>
        </div> -->
        <div v-if="host.name" :class="$globalStyle.headerItem">
          <div :class="$globalStyle.headerItemLabel">{{ $t("host-name") }}</div>
          <div :class="[$globalStyle.headerItemText]">
            {{ host.name }}
          </div>
        </div>
        <!-- <div v-if="joinCode" :class="$globalStyle.headerItem">
          <div :class="$globalStyle.headerItemLabel">{{ $t("code") }}</div>
          <div :class="[$globalStyle.headerItemText]">
            {{ joinCode }}
          </div>
        </div> -->
        <div v-if="playerGroup?.name" :class="$globalStyle.headerItem">
          <div :class="$globalStyle.headerItemLabel">{{ $t("group") }}</div>
          <div :class="[$globalStyle.headerItemText]">
            {{ playerGroup.name }}
          </div>
        </div>
      </div>
      <div :class="$globalStyle.headerRight">
        <div v-if="showRoleButton" :class="$globalStyle.headerItem">
          <HeaderItemButton
            :text="$t('see-role')"
            :clickFunction="openRoleModal"
            backBg="#000000"
            frontBg="#676767"
            textColor="#ffc642"
            :button-width="isTablet ? '92px' : '110px'"
          />
        </div>
        <div v-if="gameWinner" :class="$globalStyle.headerItem">
          <div :class="$globalStyle.headerItemLabel">
            {{ gameWinner === "None" ? "Result" : $t("game-winner") }}
          </div>
          <div :class="[$globalStyle.headerItemText, $globalStyle.headerItemPlayerWinnerText]">
            {{ gameWinner === "None" 
                ? $t("game-tied") 
                : gameWinner === "Players" 
                  ? $t("players") 
                  : gameWinner === "Saboteur" 
                    ? $t("saboteur") 
                    : gameWinner 
            }}
          </div>
        </div>
        <div :class="$globalStyle.headerItem">
          <HeaderLanguageSelector />
        </div>
      </div>
    </template>
  </div>
  <!-- <div :class="[$globalStyle.headerRightCta]">
      <UtilButton
        text="Start Game"
        :iconLink="forwardArrowIcon"
        :clickFunction="startGame"
        backBg="#000000"
        frontBg="#676767"
        textColor="#FFFFFF"
        :rightIcon="true"
        buttonHeight="48px"
      />
    </div> -->
</template>

<script>
// import UtilButton from "../util/UtilButton.vue";
import globalStyles from "@/css/global.module.css";
import HeaderLanguageSelector from "../util/HeaderLanguageSelector.vue";
import useDeviceType from "@/utils/useDeviceType";
import HeaderItemButton from "../buttons/HeaderItemButton.vue";
import HeaderMenuIcon from "@/assets/icons/header-menu-white.svg";
import PlayerMobileHeader from "./PlayerMobileHeader.vue";

const device = useDeviceType();

export default {
  components: { HeaderLanguageSelector, HeaderItemButton, PlayerMobileHeader },
  name: "PlayerHeaderBox",
  props: {
    user: {
      type: Object,
      required: true,
    },
    allowedPlayers: {
      type: Number,
      required: true,
    },
    playersJoined: {
      type: Number,
      required: true,
    },
    host: {
      type: Object,
      required: true,
    },
    joinCode: {
      type: Number,
      required: true,
    },
    realTextLabel: {
      type: String,
      required: false,
      default: "",
    },
    isSaboteur: {
      type: Boolean,
      required: false,
      default: false,
    },
    saboteur: {
      type: Object,
      required: false,
      default: () => {},
    },
    gameWinner: {
      type: String,
      required: false,
      default: "",
    },
    playerGroup: {
      type: Object,
      required: false,
      default: () => {},
    },
    showRoleButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    openRoleModal: {
      type: Function,
      required: true,
    },
    // showRole: {
    //   type: Boolean,
    //   required: true,
    // },
  },
  data() {
    return {
      headerMenuIcon: HeaderMenuIcon,
      isMobileHeaderOpen: false,
    };
  },
  computed: {
    $globalStyle() {
      return globalStyles;
    },
    width() {
      return device.width.value;
    },
    height() {
      return device.height.value;
    },
    isMobile() {
      return device.isMobile.value;
    },
    isTablet() {
      return device.isTablet.value;
    },
    isDesktop() {
      return device.isDesktop.value;
    },
  },
  methods: {
    toggleMobileHeader() {
      this.isMobileHeaderOpen = !this.isMobileHeaderOpen;
    },
  },
};
</script>

<style scoped></style>
